import React from "react";
import style from "./index.module.scss";

export default function SubmitError() {
    return (
        <div className={style.root}>
            添加题目失败!
            <p>必填项检查不通过, 请检查并填写后重试</p>
        </div>
    );
}
